import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SupportCaseStatusBadge } from './SupportCaseStatusBadge';
import type { SupportCaseStatus } from '../types/supportCase';

interface Props {
  readonly caseId: string;
  readonly status: SupportCaseStatus;
}

export const SupportCaseIndicator = ({ caseId, status }: Props) => {
  const { t } = useTranslation('pages');

  return (
    <Link
      to={`/support-cases?caseId=${encodeURIComponent(caseId)}`}
      aria-label={t('supportCaseIndicatorAriaLabel')}
      className="inline-flex items-center gap-1.5 text-sm hover:opacity-80"
    >
      <SupportCaseStatusBadge status={status} />
    </Link>
  );
};
